<template>
    <div class="recepcion">
        <audio
            ref="audio"
            src="@/assets/tono-mensaje-3-.mp3">
        </audio>
        <div class="modal-list" :class="{'display': !isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Generar venta manual</h3>
                    <input v-if="modelSelected" type="text" v-model="searchProductValue" v-on:keyup="checkProductTrigger" @keyup.enter="onProductEnter">
                </center>
                <toggle-button
                    v-model="paymode"
                    class="toggle"
                    color="#82C7EB"
                    :sync="true"
                    :width="100"
                    :height="40"
                    :labels="{checked: 'PAGADA', unchecked: 'NO PAGA'}"
                    v-if="modelSelected"/>
                <h4>{{ priceFormat(manualSum) }}</h4>
                <span v-if="modelSelected" @click="change"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                                <label for="">{{ model.type }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="products-info">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                            <label for="">{{ userTypeSelect }}</label>
                        </div>
                        <button @click="pedido()" v-if="!isPedido">Ver pedido</button>
                    </div>
                    <div class="category-list" v-if="!categorySelected && !isPedido">
                        <div v-for="(item, index) in categories" :key="index" @click="selectCategory(item)">
                            <label for="">{{ item.name }}</label>
                        </div>
                    </div>
                    <div class="products-list" v-if="categorySelected && !isPedido">
                        <div v-for="(item, index) in products" :key="index" @click="selectProduct(item)">
                            <center>
                                <img :src="item.image" alt="">
                                <h5>{{ item.name }}</h5>
                                <label for="">{{ priceFormat(item.price) }}</label>
                            </center>
                        </div>
                    </div>
                    <div class="list-pedido" v-if="isPedido">
                        <div v-for="(item, index) in ledgers_manual" :key="index">
                            <center>
                                <div><img :src="item.image" alt=""></div>
                                <div><h5>{{ item.name }}</h5></div>
                                <div><input type="number" v-model="item.cantidad"></div>
                                <div><label for="">{{ priceFormat(item.price * item.cantidad) }}</label></div>
                                <div><h4 @click="deleateManualLedger(index)">X</h4></div>
                            </center>
                        </div>
                        <button @click="generateSellStore">REALIZAR PEDIDO</button>
                    </div>
                </div>
            </div>
        </div>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="solicitud" title="Generar Solicitud de Emilinacion de productos">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <h3>Generar solicitud de eliminacion de productos</h3>
                <div v-if="!solicitudSelected">
                    <table>
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Cantidad</th>
                                <th>Cantidad a eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in ledgers" :key="index">
                                <td>{{item.producto}}</td>
                                <td>{{item.cantidad}}</td>
                                <td><input type="number" name="" id="" v-model="item.cant_to_delete" min="0" :max="item.cantidad"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <div>
                        <label for="">Agregar Detalles a la solicitud</label>
                        <textarea name="" id="" cols="100" rows="10" v-model="solicitudDetails"></textarea>
                    </div>
                </div>
                <button v-if="!solicitudSelected" @click="solicitudSelected = true">Agregar detalles</button>
                <button v-else @click="solicitudEliminar()">Generar solicitud</button>
            </div>
        </b-modal>
        <div>
            <div class="title">
                <button @click="isOpen = true" class="left">Agregar venta</button>
                <h2>CONTROL DE TIENDA</h2>
                <button @click="startStore" v-if="!isStart" class="right">INICIAR TURNO</button>
                <button @click="finishStore" v-if="isStart" class="right">FINALIZAR TURNO</button>
            </div>
        </div>
        <div class="control">
            <div class="finalizadas">
                <h3>Venta Exitosa</h3>
                <div>
                    <div v-for="(item, index) in finalizadas" :key="index" @click="detalles(item, index, true)" :class="{'active': item.selected}">
                        <label for="">FINALIZADA</label>
                        <label for="">{{item.buyer}}</label>
                    </div>
                </div>
            </div>
            <div class="ledgers">
                <div>
                    <div class="details">
                        <div>
                            <div>
                                <label for="">{{userTypeDetails}}</label>
                                <h5 for="">{{modeloDetails}}</h5>
                            </div>
                            <div>
                                <label for="">Total</label>
                                <h5 for="">{{totalDetailsPrice}}</h5>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label for="">Cantidad</label>
                                <h5 for="">{{cantidadDetails}}</h5>
                            </div>
                            <div>
                                <label for="">Habitacion</label>
                                <h5 for="">{{roomDetails}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="productos">
                        <center>
                            <toggle-button
                            v-model="paymode_auto"
                            class="toggle"
                            color="#82C7EB"
                            :sync="true"
                            :width="100"
                            :height="40"
                            :labels="{checked: 'PAGADA', unchecked: 'NO PAGA'}"
                            v-if="!isFinalize"/>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>Total</th>
                                        <th v-if="!isFinalize">Sacar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in ledgers" :key="index">
                                        <td>{{item.producto}}</td>
                                        <td>
                                            <input type="number" v-model="item.cantidad" @change="changeCantidad(item.id, item.cantidad)" v-if="!isFinalize">
                                            <label for="" v-if="isFinalize">{{item.cantidad}}</label>
                                        </td>
                                        <td>{{priceFormat(item.total)}}</td>
                                        <td v-if="!isFinalize"><button @click="removeLedgerStore(item.id)" >Eliminar</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </div>
                    <div class="functions">
                        <div>
                            <button @click="finishVenta" v-if="!isFinalize">Finalizar venta</button>
                            <button @click="anularventa" v-if="!isFinalize">Anular venta</button>
                            <button @click="$refs.solicitud.show()" v-if="isFinalize">Solicitud de Eliminación</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ventas">
                <h3>Ventas</h3>
                <div>
                    <div v-for="(item, index) in ventas" :key="index" @click="detalles(item, index)" :class="{'active': item.selected}">
                        <label for="">NUEVA VENTA</label>
                        <label for="">{{item.buyer}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '../../utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'
import sound from '@/assets/tono-mensaje-3-.mp3'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    name: 'panel',
    components: {
        ToggleButton
    },
    data() {
        return {
            isStart: false,
            ventas: [],
            finalizadas: [],
            ledgers: [],
            modeloDetails: null,
            totalDetails: null,
            cantidadDetails: null,
            roomDetails: null,
            index: 0,
            userTypeDetails: null,
            buyer_id: null,
            venta_id: null,
            sameChange: false,
            intervalid: null,
            isFinalize: false,
            models: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            searchValue: '',
            searchProductValue: '',
            modelSelected: false,
            isOpen: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            categories: [],
            categoryId: null,
            categorySelected: false,
            products: [],
            ledgers_manual: [],
            isPedido: false,
            lastVenta: 0,
            solicitudSelected: false,
            solicitudDetails: null,
            paymode: false,
            paymode_auto: false
        }
    },
    computed: {
        manualSum: {
            get() {
                return this.ledgers_manual.reduce((accumulator, object) => {
                    return accumulator + (object.price * object.cantidad)
                }, 0)
            }
        },
        totalDetailsPrice: {
            get() {
                return Price(this.totalDetails)
            }
        }
    },
    metaInfo () {
        if (this.ventas.length) {
            return {
                title: this.ventas.length,
                titleTemplate: '(%s) Imperium'
            }
        } else {
            return {
                title: this.ventas.length,
                titleTemplate: 'Imperium'
            }
        }
    },
    watch: {
        searchValue: function() {
            if (this.searchValue === '') {
                this.models = []
                this.getAllModels()
            }
        },
        searchProductValue: function() {
            if (this.searchProductValue === '') {
                this.products = []
                // this.selectCategory(true)
                this.categorySelected = false
            }
        }
    },
    methods: {
        generateSellStore() {
            API.Store.generateSellStore(this.userIdSelect, this.ledgers_manual, this.paymode)
                .then((res) => {
                    if (res === false) {
                        Notify('error', 'No se genero la venta compurueba que la tienda esta abierta')
                        return
                    }
                    Notify('dirty', 'Se genero la venta para la modelo ' + this.userNameSelect + ' existosamente')
                    this.modelSelected = false
                    this.isOpen = false
                    this.userIdSelect = null
                    this.userImgselect = null
                    this.userNameSelect = null
                    this.userTypeSelect = null
                    this.categoryId = null
                    this.categorySelected = false
                    this.products = []
                    this.ledgers_manual = []
                    this.isPedido = false
                    this.models = []
                    this.paymode = false
                    this.getAllModels()
                    this.getFinalizeVentas()
                })
        },
        deleateManualLedger(index) {
            this.ledgers_manual.splice(index, 1)
            if (this.ledgers_manual <= 0) {
                this.isPedido = false
            }
        },
        pedido() {
            this.isPedido = true
        },
        selectProduct(item) {
            var info = {
                id: item.id,
                cantidad: 1,
                image: item.image,
                name: item.name,
                price: item.price
            }
            this.ledgers_manual.push(info)
            Notify('dirty', 'Se agrego ' + item.name + 'a la lista de pedidos')
        },
        selectCategory(item) {
            this.products = []
            this.categories.map(model => { model.select = false })
            var searchValueinitial = ''
            if (this.searchProductValue !== '' && item === true) {
                var stagenameSeparate = this.searchProductValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchProductValue
                }
            } else if (this.searchProductValue === '' && item === true) {
                this.categorySelected = false
                return
            } else {
                searchValueinitial = this.searchProductValue
            }
            API.Store.getProductsListByCategory(item === true ? searchValueinitial : item.name, item === true ? 'name' : 'category')
                .then((res) => {
                    this.products = res
                    if (item !== true) {
                        item.select = true
                    }
                    this.categoryId = item.id
                    this.categorySelected = true
                })
        },
        change() {
            if (this.isPedido) {
                this.isPedido = !this.isPedido
                this.categorySelected = false
                return
            }
            if (this.categorySelected) {
                this.categorySelected = !this.categorySelected
                return
            }
            this.models.map(model => { model.select = false })
            this.modelSelected = !this.modelSelected
        },
        getCategoriesList() {
            API.Store.getCategories()
                .then((res) => {
                    this.categories = res
                })
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limit = 20
                this.offset = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limit = 20
                this.offset = 0
                this.models = []
                this.searchModel()
            }
        },
        checkProductTrigger(e) {
            if (e.keyCode === 13) {
                this.products = []
                this.searchProduct()
            } else if (this.searchProductValue.length > 0) {
                this.products = []
                this.searchProduct()
            } else {
                this.categorySelected = false
            }
        },
        onEnterProduct () {
            this.searchProduct()
        },
        searchProduct() {
            this.modelSearch = false
            this.selectCategory(true)
        },
        onEnter () {
            this.searchModel()
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limit : 'ALL'
            const offset = this.searchValue === '' ? this.offset : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.Store.getAllModelsStore(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offset += this.limit
                        this.itemFlag = true
                    }
                })
        },
        loadMore() {
            if (this.searchValue !== '') {
                return
            }
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.models.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAllModels()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        logOut() {
            this.$store.commit('logOut')
            this.$router.push('/login')
        },
        changeCantidad(id, cantidad) {
            API.Store.changeCantidadProducto(id, cantidad)
                .then(() => {
                    clearInterval(this.intervalid)
                    this.getOpenVentas()
                    Notify('dirty', 'Se ha cambiado la cantidad del producto con exito')
                })
        },
        removeLedgerStore(id) {
            API.Store.removeLedgerStore(id)
                .then(() => {
                    clearInterval(this.intervalid)
                    this.getOpenVentas()
                    Notify('dirty', 'Se ha eliminado el producto con exito')
                })
        },
        priceFormat: function(item) {
            return Price(item)
        },
        detalles(venta, index, finalize = false) {
            this.ledgers = []
            this.userTypeDetails = venta.user_type
            this.index = index
            this.venta_id = venta.id
            if (!finalize) {
                this.ventas.forEach(venta => { venta.selected = false })
            } else {
                this.finalizadas.forEach(venta => { venta.selected = false })
            }
            venta.selected = true
            this.modeloDetails = venta.buyer
            this.buyer_id = venta.buyer_id
            this.totalDetails = venta.total
            this.cantidadDetails = venta.cantidad
            this.roomDetails = venta.room
            this.ledgers = venta.ledgers.map(ledger => {
                return {
                    id: ledger.id,
                    venta_id: ledger.venta_id,
                    producto: ledger.producto,
                    categoria: ledger.categoria,
                    total: ledger.total,
                    cantidad: ledger.cantidad,
                    detalles: ledger.detalles,
                    cant_to_delete: 0
                }
            })
            this.isFinalize = finalize
        },
        finishStore() {
            API.Store.closeStore()
                .then((res) => {
                    this.$store.commit('logOut')
                    this.$router.push('/login')
                })
        },
        finishVenta() {
            API.Store.closeVenta(this.venta_id, this.paymode_auto)
                .then((res) => {
                    this.paymode_auto = false
                    clearInterval(this.intervalid)
                    this.getOpenVentas()
                    this.getFinalizeVentas()
                    Notify('dirty', 'La venta se ha finalizado con exito')
                })
        },
        anularventa() {
            API.Store.removeVenta(this.venta_id)
                .then((res) => {
                    clearInterval(this.intervalid)
                    this.getOpenVentas()
                    Notify('dirty', res)
                })
        },
        solicitudEliminar() {
            if (!this.solicitudDetails) {
                return
            }
            API.Store.solicitudEliminar(this.ledgers, this.buyer_id, this.solicitudDetails)
                .then((res) => {
                    this.$refs.solicitud.hide()
                    Notify('dirty', res)
                })
        },
        getOpenVentas() {
            API.Store.getOpenVentas()
                .then((res) => {
                    this.ventas = []
                    this.userTypeDetails = null
                    this.index = null
                    this.venta_id = null
                    this.modeloDetails = null
                    this.totalDetails = null
                    this.cantidadDetails = null
                    this.roomDetails = null
                    this.ledgers = null
                    if (res === 'Se registro el primer ledger') {
                        this.getOpenVentas()
                    } else {
                        if (this.index === null) {
                            this.index = 0
                        }
                        if (this.index >= 0 && res[0] && res[0].ledgers && res[0].ledgers.length) {
                            this.ventas = res
                            this.detalles(this.ventas[this.index], this.index)
                        }
                        this.intervalid = setInterval(() => {
                            if (this.$route.name !== 'recepcion') {
                                return
                            }
                            API.Store.getOpenVentas()
                                .then((res) => {
                                    if (!res || res === 'Se registro el primer ledger') {
                                        this.ventas = []
                                        this.userTypeDetails = null
                                        this.index = null
                                        this.venta_id = null
                                        this.modeloDetails = null
                                        this.totalDetails = null
                                        this.cantidadDetails = null
                                        this.roomDetails = null
                                        this.ledgers = null
                                        clearInterval(this.intervalid)
                                        this.getOpenVentas()
                                    } else {
                                        if (this.index === null) {
                                            this.index = 0
                                        }
                                        if (this.index >= 0 && res[0] && res[0].ledgers && res[0].ledgers.length) {
                                            this.ventas = res
                                            if (this.ventas.length > this.lastVenta) {
                                                const audio = new Audio(sound)
                                                audio.play()
                                            }
                                            this.lastVenta = this.ventas.length
                                            // this.detalles(this.ventas[this.index], this.index)
                                        }
                                    }
                                })
                        }, 2000)
                    }
                })
        },
        startStore() {
            API.Store.startStore()
                .then((res) => {
                    this.isStart = !this.isStart
                    this.getOpenVentas()
                    Notify('dirty', 'Se inicio el proceso de venta')
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getFinalizeVentas() {
            API.Store.getFinalizeVentas()
                .then((res) => {
                    this.finalizadas = res
                })
        },
        getLastStoreStatus() {
            API.Store.getLastStoreStatus()
                .then(res => {
                    this.isStart = res.isOpen
                    this.getOpenVentas()
                })
        }
    },
    mounted() {
        this.getLastStoreStatus()
        this.getFinalizeVentas()
        this.getAllModels()
        this.getCategoriesList()
    }
}
</script>

<style scoped>
    .recepcion {
        width: 100%;
        height: 100vh;
        background-color: #cdcdcd;
    }
    .recepcion > .display{
        display: none;
    }
    .recepcion > div{
        height: 15%;
        position: relative;
        width: 100%;
        color: #FFF;
        border-radius: 20px;
        padding: 10px;
    }
    .recepcion > div.modal-list {
        padding: 40px;
        position: fixed;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99;
        border-radius: 0px;
    }
    .recepcion > div.modal-list > div{
        background-color: #FFF;
        height: 100%;
        width: 100%;
        padding: 20px;
        color: #000;
        position: relative;
    }
    .recepcion > div.modal-list > div > h4 {
        position: absolute;
        right: 100px;
    }
    .recepcion > div.modal-list > div > center > input {
        width: 50%;
        height: 40px;
        border-radius: 20px;
        text-align: center;
    }
    .recepcion > div.modal-list > div > .toggle {
        position: absolute;
        right: 250px;
    }
    .recepcion > div.modal-list > div > div.products-info {
        width: 100%;
        height: 90%;
        display: flex;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido{
        padding: 50px;
        width: 100%;
        height: 80%;
        overflow: auto;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div{
        width: 100%;
        height: 100px;
        margin-bottom: 20px;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center {
        width: 100%;
        background-color: #2b2926;
        padding: 10px;
        height: 100%;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center > div {
        width: 18%;
        height: 100%;
        text-align: center;
        color: #FFF;
        display: inline-block;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center > div > img {
        width: 50%;
        height: 100%;
        object-fit: cover;
        display: inline-block;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center > div > h5 {
        width: 100%;
        color: #FFF;
        text-align: center;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center > div > input {
        width: 80px;
        height: 40px;
        text-align: center;
    }
    .recepcion > div.modal-list > div > div.products-info > .list-pedido > div > center > div > label {
        width: 150px;
    }
    .recepcion > div.modal-list > div > div.products-info > .products-list{
       padding: 50px;
       width: 100%;
       height: 95%;
       overflow: auto;
    }
    .recepcion > div.modal-list > div > div.products-info > .products-list > div{
       width: 27%;
       display: inline-block;
       height: 350px;
       position: relative;
       background-color: #2b2926;
       margin: 20px;
    }
    .recepcion > div.modal-list > div > div.products-info > .products-list > div > center {
        width: 100%;
        padding: 20px;
        color: #FFF;
    }
    .recepcion > div.modal-list > div > div.products-info > .products-list > div > center > img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 30px;
    }
    .recepcion > div.modal-list > div > div.products-info > .category-list{
       padding: 50px;
       width: 100%;
       height: 95%;
       overflow: auto;
    }
    .recepcion > div.modal-list > div > div.products-info > .category-list > div{
       width: 27%;
       display: inline-block;
       height: 150px;
       position: relative;
       background-color: #2b2926;
       margin: 20px;
    }
    .recepcion > div.modal-list > div > div.products-info > .category-list > div > label {
        position: absolute;
        color: #FFF;
        font-weight: bolder;
        font-size: 20;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .recepcion > div.modal-list > div > div.products-info > div.model-info {
        width: 30%;
        height: 100%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .recepcion > div.modal-list > div > div.products-info > div.model-info > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .recepcion > div.modal-list > div > div.products-info > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .recepcion > div.modal-list > div > div.products-info > div.model-info > div {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .recepcion > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .recepcion > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .recepcion > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .recepcion > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .recepcion > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .recepcion > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .recepcion > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .recepcion > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .recepcion > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .recepcion > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .recepcion > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .recepcion > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 200px;
        height: 200px;
        object-fit: cover;
    }
    .recepcion > div > div.title{
        padding: 20px;
        background-color: #e0b059;
        border-radius: 20px;
        height: 100%;
    }
    .recepcion > div > div > h2{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .recepcion > div > div > button.left{
        position: absolute;
        top: 50%;
        left: 10%;
        transform: translate(0, -50%);
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .recepcion > div > div > button.right{
        position: absolute;
        top: 50%;
        right: 10%;
        transform: translate(0, -50%);
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .recepcion > .control {
        height: 85%;
        display: flex;
    }
    .recepcion > .control > .finalizadas{
        height: 100%;
        width: 25%;
        background-color: #8363b7;
        border-style: outset;
        padding: 10px;
        text-align: center;
        border-radius: 20px;
        overflow: auto;
    }
    .recepcion > .control > .ledgers{
        height: 100%;
        width: 45%;
        padding: 10px;
        text-align: center;
    }
    .recepcion > .control > .ledgers > div {
        position: relative;
        height: 100%;
    }
    .recepcion > .control > .ledgers > div > .details{
        background-color: #63b1b7;
        padding: 20px;
        margin: 10px;
        margin-top: 0px;
        height: 35%;
        border-radius: 20px;
        border-style: outset;
    }
    .recepcion > .control > .ledgers > div > .details > div{
        width: 100%;
        display: flex;
    }
    .recepcion > .control > .ledgers > div > .details > div > div{
        width: 50%;
        display: grid;
        background-color: #585858;
        border-radius: 20px;
        margin: 5px;
    }
    .recepcion > .control > .ledgers > div > .details > div > div > label{
        color: #000;
        font-weight: bold;
    }
    .recepcion > .control > .ledgers > div > .productos {
        padding: 20px;
        background-color: #63b763;
        height: 52%;
        margin: 10px;
        border-radius: 20px;
        border-style: outset;
    }
    .recepcion > .control > .ledgers > div > .productos > center {
        height: 280px;
        overflow-y: auto;
    }
    .recepcion > .control > .ledgers > div > .productos > center > .toggle{
        position: absolute;
        right: 15px;
    }
    .recepcion > .control > .ledgers > div > .productos > center > table > thead > tr > th{
        padding: 10px;
        text-align: center;
    }
    .recepcion > .control > .ledgers > div > .productos > center > table > tbody > tr > td{
        padding: 20px;
        text-align: center;
    }
    .recepcion > .control > .ledgers > div > .productos > center > table > tbody > tr > td > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        padding: 10px;
    }
    .recepcion > .control > .ledgers > div > .productos > center > table > tbody > tr > td > input{
        width: 70px;
        text-align: center;
    }
    .recepcion > .control > .ledgers > div > .functions {
        margin: 10px;
        padding: 10px;
        border-radius: 20px;
        height: 10%;
        position: relative;
        border-style: outset;
    }
    .recepcion > .control > .ledgers > div > .functions > div{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .recepcion > .control > .ledgers > div > .functions > div > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        padding: 10px;
    }
    .recepcion > .control > .ventas {
        height: 100%;
        width: 30%;
        background-color: #585858;
        border-style: outset;
        padding: 10px;
        text-align: center;
        border-radius: 20px;
    }
    .recepcion > .control > .ventas > div {
        padding: 20px;
    }
    .recepcion > .control > .ventas > div > div{
        background-color: #63b1b7;
        border-radius: 20px;
        border-style: outset;
        font-weight: bold;
        height: 40px;
        cursor: pointer;
    }
    .recepcion > .control > .ventas > div > div.active{
        background-color: #63b763;
    }
    .recepcion > .control > .ventas > div > div > label{
        text-transform: uppercase;
        width: 49%;
        cursor: pointer;
    }
    .recepcion > .control > .finalizadas > div {
        padding: 20px;
    }
    .recepcion > .control > .finalizadas > div > div{
        background-color: #63b1b7;
        border-radius: 20px;
        border-style: outset;
        font-weight: bold;
        height: 40px;
        cursor: pointer;
        margin: 20px;
    }
    .recepcion > .control > .finalizadas > div > div.active{
        background-color: #63b763;
    }
    .recepcion > .control > .finalizadas > div > div > label{
        text-transform: uppercase;
        width: 49%;
        cursor: pointer;
    }
    .info-wrapper > div {
        padding: 20px;
    }
    .info-wrapper > div > table > thead > tr > th{
        border-style: outset;
        text-align: center;
        padding: 20px;
    }
    .info-wrapper > div > table > tbody > tr > td{
        border-style: outset;
        text-align: center;
        padding: 20px;
    }
    .info-wrapper > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        border-radius: 30px;
        padding: 10px;
    }
    .info-wrapper > div > div {
        display: grid;
    }
    .info-wrapper > div > div > label {
        font-weight: bolder;
        margin: 20px;
    }
    .info-wrapper > div > div > textarea {
        border-radius: 20px;
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Resepcionist/Panel.vue